import { render, staticRenderFns } from "./ppgs.vue?vue&type=template&id=356fc737&scoped=true&"
import script from "./ppgs.vue?vue&type=script&lang=js&"
export * from "./ppgs.vue?vue&type=script&lang=js&"
import style0 from "./ppgs.vue?vue&type=style&index=0&id=356fc737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356fc737",
  null
  
)

export default component.exports